import {gql} from "@apollo/client";

export const GET_HOCKEY_GAME_TIMELINE = gql`
  query GetHockeyGameTimeline($gameId: Int!, $teamId: Int!) {
    getTeamRosterForLineup(gameId: $gameId, teamId: $teamId) {
      player { id fullName }
      position { key name }
      jerseyNumber
    }
    hockeyPlayerScoresByGame(gameId: $gameId) {
      id
      period
      minute
      second
      actionType
      penaltyType
      penaltyMinutes
      notes
      player { id fullName }
      relatedPlayer { id fullName }
      team { id name }
    }
  }
`;
